module.exports = __webpack_public_path__ + "static/media/Bluelab pH Probe.d6efad89.webp";